export default __webpack_public_path__ + "static/gs-6-explainmodel-1e8bca798e825510542974ff9720969c.webp";